import { useSyncExternalStore } from 'react';
import { getChatToken, subscribeChatToken } from '../ApiClientArchitecture/tokenStore';

/** The current chat token; components re-render when it is set, refreshed or cleared. */
export const useChatToken = (): string | undefined => useSyncExternalStore(subscribeChatToken, getChatToken);
